import React from 'react'
import PropTypes from 'prop-types'

// import { ReactComponent as Star } from "./assets/star-solid.svg" // for storybook
import Star from 'images/inline/star-solid.svg' // gatsby special treament for svgs under /inline/ folder

export default class ClickableStar extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    isActive: PropTypes.bool,
    activeColor: PropTypes.string,
    onClick: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseLeave: PropTypes.func,
  }

  constructor(props) {
    super()

    this.state = {
      isActive: props.isActive || false,
    }

    this.ref = React.createRef()
    this.onClick = this.onClick.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  onClick(e) {
    if (this.props.onClick) {
      this.props.onClick(this.props.value)
    }
  }

  onMouseOver(e) {
    if (this.props.onMouseOver) {
      this.props.onMouseOver(this.props.value)
    }
  }

  onMouseLeave(e) {
    // e.stopPropagation();

    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(this.props.value)
    }
  }

  get color() {
    return this.props.delay !== undefined
      ? this.props.delay
      : this.props.trigger === 'hover'
      ? 100
      : 0
  }

  render() {
    return (
      <>
        <Star
          style={{
            display: 'inline',
            width: '32px',
            color: this.props.isActive ? 'orange' : 'white',
          }}
          onClick={this.onClick}
          onMouseOver={this.onMouseOver}
          onMouseLeave={this.onMouseLeave}
        />
      </>
    )
  }
}
